import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import UnderConstruction from "../container/Blank/UnderConstruction";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Transportation = () => {
  const show = true;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2024" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div className="entry-content">
            <h3>Tan Son Nhat International Airport</h3>
            <br />

            <p>
              <img
                src="./images/xigong/airport1.png"
                width={650}
              // height={300}
              />

            </p>

            <p>
            Tan Son Nhat International Airport, located in Ho Chi Minh City, is the busiest airport in Vietnam in terms of passenger traffic. Serving as a crucial hub for travel within Southeast Asia, the airport is situated about 6 kilometers north of the city center. It has two main terminals: Terminal 1, which handles domestic flights, and Terminal 2, dedicated to international flights.
            <br></br>
            <br></br>

              <p>
                <img
                  src="./images/xigong/airport2.png"
                  width={650}
                // height={300}
                />
              </p>
              <br></br>

            </p>
            The airport is named after the nearby village of Tan Son Nhat and has undergone significant expansions and renovations to accommodate the growing number of travelers each year. Facilities at the airport include a range of dining and shopping options, lounges, currency exchange services, and car rental agencies. Despite its busy nature, Tan Son Nhat International Airport is known for its efficiency in handling the large volume of passengers that pass through its doors daily.

            <p>
              For more information, please visit{" "}
              <a href="https://www.hochiminhcityairport.com/">Tan Son Nhat International Airport </a>
            </p>

            <hr></hr>
            <h3>Saigon railway station</h3>
            <br />
            <img
              src="./images/xigong/railwaystation.jpg"
              width={650}
            /> 
            <p>
            Saigon Railway Station serves as a key transportation hub in Vietnam. Located in District 3, it is the terminus for the main railway line that runs from Ho Chi Minh City to Hanoi, covering a distance of approximately 1,726 kilometers. This railway station is crucial for both passenger and freight services connecting major cities across the country.
                <p>
                <img
                  src="./images/xigong/railwaystation2.png"
                  width={650}
                />
              </p>
            <br></br>
            The station building features a blend of Soviet-style architecture and local Vietnamese elements, reflecting its historical significance. It offers various facilities including ticket offices, waiting areas, and a range of services for passengers. Additionally, the station is surrounded by a bustling area with numerous shops and eateries, providing travelers with convenient access to goods and services. Saigon Railway Station is not only a vital part of Vietnam&apos;s rail network but also a significant cultural and historical landmark in Ho Chi Minh City.  
            </p>

            {/* <hr></hr> */}
{/* 
            <h3>Nanning East Railway Station</h3>
            <br />
            <img
              src="./images/nanning/nanninge.png"
              width={650}
            />
            <br></br>
            <p>
            Nanning East Railway Station, inaugurated in 2014, is a modern transportation hub situated in the eastern part of Nanning city, the capital of Guangxi Zhuang Autonomous Region, China. 
            This station is a part of the country&apos;s extensive high-speed rail network and primarily serves high-speed trains, including services on the Nanning-Guangzhou line. 
                <p>
                <img
                  src="./images/nanning/nanninge2.png"
                  width={650}
                />
              </p>
              <br></br>
            With its sleek and contemporary design, the station provides passengers with state-of-the-art facilities and a seamless travel experience. 
            It has become a critical link for regional connectivity, contributing to the economic development of Guangxi and enhancing the accessibility to and from other major cities in China and neighboring countries.
            
            </p> */}



            {/* <p>
              From Qingdao Railway Station -&gt; Subway line 3 -&gt; May Fourth
              Square Station -&gt; Subway line 2 -&gt; Miaoling Road Station
              -&gt; Qingdao Blue Horizon Hotel Laoshan
            </p>

            <p>&nbsp;</p>
            <h3>To Ocean University Station</h3>
            <p>
              <img
                src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/transport.jpg"
                width={400}
              />
            </p>
            <p>
              From Qingdao International Airport -&gt; 701 Busline Qingdao
              International Airport Station -&gt; Qingdao Car East Station -&gt;
              Subway line 2, Liaoyang East Road Station -&gt; Miaoling Road
              Station -&gt; Subway line 11 , Miaoling Road Station -&gt; Ocean
              University Station
            </p>
            <p>
              Travel time from the airport to Ocean University of China is one
              and a half hours. Airport Line 1 (bus 701) runs every hour from
              the airport to the East Bus Station and tickets can be purchased
              at the ticket counter in the bus for 20RMB in cash or by using the
              Qindao Pass card on the bus, then transfer to Metro Line 2 and
              change to Metro Line 11 in the station to reach Ocean University
              Station and tickets can be purchased at the ticket machine in the
              Metro station for 4RMB.
            </p> */}
          </div>
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Transportation | DMBD 2024" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Transportation"
          content="For Participants"
          contentTwo="Transportation"
          linkage="/"

        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <UnderConstruction />
        </EmptyTwo>
        {/* <AboutFive />
				  <TestimonialContainer classOption="bg-primary-blue" />
				  <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
};

export default Transportation;
